import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";

export default function CustomInputAutocomplete({ options, onChange:setVal, text, value }) {
  return (
    <Autocomplete
      sx={{
        "& input": {
          width: "100% !important"
        },
      }}
      id="custom-input-demo"
      options={options}
      value={value}
      renderInput={(params) => (
        <div ref={params.InputProps.ref}>
          <input placeholder={text?text:'Select Bank'} type="text" {...params.inputProps} className="form-input"/>
        </div>
      )}
      onChange={(e) => {
        setVal(e.target.innerText)
      }}
    />
  );
}
